export default __webpack_public_path__ + "static/media/Survey Vector Dark.acf4fc91.svg";